import { scrollToYOffset } from '../../../helpers/scroll-to-helper';
import GenericShow from '../../show/show';

export default class PlaceShow extends GenericShow {
  _getDOM() {
    super._getDOM();
    this.dom.priceAnchor = this.dom.page.querySelector('#price-anchor-js');
    this.dom.priceTarget = this.dom.page.querySelector('#prix');
    this.dom.tabsLinks = this.dom.page.querySelectorAll('.nav-link');
    this.dom.tabsPanes = this.dom.page.querySelectorAll('.tab-pane');
  }

  _bind() {
    super._bind();
    this._handleTabs();
    this._handlePriceAnchorScroll();
  }

  _handleTabs() {
    // handle initial loading state
    if (window.location.hash === '#logistique') {
      this._activateTabLink(this.dom.page.querySelector('#logistics-tab'));
    }
    // handle clicks on tabs links
    this.dom.tabsLinks.forEach((element) => {
      element.addEventListener('click', () => this._activateTabLink(element));
    });
  }

  _activateTabLink(tabLinkElement) {
    // prevent non necessary execution if trying to activate already activated tab
    if (tabLinkElement.classList.contains('active')) {
      return;
    }
    // handle tab links state
    this.dom.tabsLinks.forEach((link) => {
      if (link !== tabLinkElement) {
        link.classList.remove('active');
      } else {
        link.classList.add('active');
      }
    });
    // handle tab panes state
    this.dom.tabsPanes.forEach((pane) => {
      if ('#' + pane.getAttribute('id') === tabLinkElement.getAttribute('data-bs-target')) {
        pane.classList.add('active');
      } else {
        pane.classList.remove('active');
      }
    });
    // handle browser url change if needed
    if (tabLinkElement.getAttribute('data-bs-target') === '#logistics') {
      history.replaceState(null, null, '#logistique');
    } else {
      history.replaceState(null, null, window.location.pathname);
    }
    // call the resize handler to prevent layout shifts after tab content height has changed
    this.resize();
  }

  _handlePriceAnchorScroll() {
    if (this.dom.priceAnchor) {
      this.dom.priceAnchor.addEventListener('click', (e) => {
        e.preventDefault();
        // activate description tab before attempting to scroll
        this._activateTabLink(this.dom.page.querySelector('#description-tab'));
        scrollToYOffset(this.dom.priceTarget.offsetTop - 25);
      });
    }
  }
}
